// import {
//     DocumentDuplicateIcon,
//     HandThumbDownIcon,
//     HandThumbUpIcon,
//     InformationCircleIcon,
// } from '@heroicons/react/24/outline';
import { useEffect, useRef } from 'react';
import { IChatMessage } from '../../../../libs/models/ChatMessage';
// import { useAppSelector } from '../../../../redux/app/hooks';
// import { RootState } from '../../../../redux/app/store';
import { ChatItem } from './ChatItem/ChatItem';
import { LoadingMessage } from './Shared/LoadingMessage';
import { WebsocketErrorDialog } from '../Dialogs/WebsocketErrorDialog';

interface ChatProps {
    chatMode: string;
    messageId?: string;
    loadingMessages: boolean;
    messages: IChatMessage[] | undefined;
}

export const Chat: React.FC<ChatProps> = ({ chatMode, loadingMessages, messages, messageId }) => {
    //const { conversations, selectedId } = useAppSelector((state: RootState) => state.conversations);
    // const chatState = conversations[selectedId];
    const messageRefs = useRef({});

    useEffect(() => {
        // Only try to scroll if we have a valid messageID and messages are ready
        if (!loadingMessages && messageId && messages && messages.length > 0) {
            const messageElement: HTMLDivElement = messageRefs.current[messageId];
            if (messageElement) {
                console.log('Scrolling to message ID:', messageId);
                messageElement.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
            } else {
                console.log('Message element not found for ID:', messageId);
            }
        }
    }, [messages, loadingMessages, messageId]);
    return (
        <>
            {loadingMessages ? (
                <LoadingMessage message="Loading messages..." />
            ) : (
                <>
                    {messages &&
                        messages.length > 0 &&
                        messages.map((message, index) => (
                            <ChatItem
                                messageRef={(el) => {
                                    if (el && message.id) {
                                        messageRefs.current[message.id.toLowerCase()] = el;
                                    }
                                }}
                                key={message.timestamp}
                                chatMode={chatMode}
                                message={message}
                                messageIndex={index}
                            />
                        ))}

                    <WebsocketErrorDialog />
                </>
            )}
        </>
    );
};
